module.exports = __webpack_public_path__ + "static/media/1011755.46c8ae09.png";